import React, { useState, useEffect } from "react";
import { Table, Pagination, } from "react-bootstrap";
import { FiFileText } from "react-icons/fi";
import { Link, } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getNotice } from "../../store/slices/notice";
import { toast } from "react-hot-toast";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

export default function StudentNotices() {
  const dispatch = useDispatch();


  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(25);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [totalData, setTotalData] = useState(0);

  const fetchNotice = () => {
    setIsLoading(true);

    dispatch(getNotice())
      .unwrap()
      .then((res) => {
        const notices = res?.data || [];
        setData(notices);
        setTotalData(res?.totalDataCount || notices.length);
      })
      .catch(({ message }) => {
        console.error(message);
        toast.error("Failed to fetch Noticedetails ");
        setData([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchNotice();
  }, []);



  // total page
  const totalPages = Math.ceil(totalData / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = data.slice(
    startIndex,
    startIndex + itemsPerPage
  );


  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/student/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>


            <FiChevronRight className="separator" />

            <span className="active">Notice</span>
          </div>

        </div>
      </div>

      <div className="staff-card">


        {/* Table */}
        <div className="table-responsive">
          <Table className="staff-table align-middle">
            <thead>
              <tr>

                <th>#</th>
                <th>Date</th>
                <th>Details</th>
                <th>For</th>
                <th>File</th>

              </tr>
            </thead>

            <tbody>
              {paginatedData.map((s, i) => (
                <tr key={s._id}>

                  <td>{i + 1}</td>

                  <td className="staff-name">
                    {new Date(s.date).toLocaleDateString("en-GB")}
                  </td>

                  <td>{s.description}</td>

                  <td>
                    {s.usertype === 1
                      ? "Students"
                      : s.usertype === 2
                        ? "Staff"
                        : s.usertype === 3
                          ? "Teacher"
                          : "-"}

                  </td>

                  <td>
                    {s.files?.length > 0 ? (
                      <FiFileText
                        size={18}
                        style={{ cursor: "pointer", color: "#2563eb" }}
                        onClick={() => window.open(s.files[0], "_blank")}
                      />
                    ) : (
                      "-"
                    )}
                  </td>


                </tr>
              ))}

              {!isLoading && paginatedData.length === 0 && (
                <tr>
                  <td colSpan="6" className="text-center">
                    No notices found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="d-flex justify-content-end my-3">
          <Pagination className="mb-0">

            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage((p) => p - 1)}
            />

            {Array.from({ length: totalPages }, (_, index) => {
              const page = index + 1;

              // Show first page, last page, and pages around current page
              if (
                page === 1 ||
                page === totalPages ||
                (page >= currentPage - 1 && page <= currentPage + 1)
              ) {
                return (
                  <Pagination.Item
                    key={page}
                    active={page === currentPage}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </Pagination.Item>
                );
              }

              // Left dots
              if (page === currentPage - 2) {
                return <Pagination.Ellipsis key={`left-${page}`} disabled />;
              }

              // Right dots
              if (page === currentPage + 2) {
                return <Pagination.Ellipsis key={`right-${page}`} disabled />;
              }

              return null;
            })}

            <Pagination.Next
              disabled={currentPage === totalPages || totalPages === 0}
              onClick={() => setCurrentPage((p) => p + 1)}
            />

          </Pagination>
        </div>

      </div>
    </>
  );
}
